export default __webpack_public_path__ + "static/media/MSC.42852374.png";